import { baseApiForNurse } from "./baseApi";

export const dashboardApi = baseApiForNurse.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: () => {
        return {
          url: "training-category",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getAllContinueBatches: builder.query({
      query: () => {
        return {
          url: "training?is_enrolled=1",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getRecommendedTraining: builder.query({
      query: () => {
        return {
          url: "training?is_enrolled=0",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const { useGetAllCategoriesQuery, useGetAllContinueBatchesQuery, useGetRecommendedTrainingQuery } = dashboardApi;
